import * as THREE from 'three';

//Shift box if the box min vertical axis isn't at 0
export const computeCorrectedBoundingBox = (box, object) => {
  if (!object) return;

  // Correct only if the center is off
  if (box.min.y !== 0) {
    const offset = new THREE.Vector3(0, -box.min.y, 0);
    box.min.add(offset);
    box.max.add(offset);
  }
  return box;
};

export const computeScaledBoundingBox = (object) => {
  const box = new THREE.Box3();
  const originalBox = new THREE.Box3().setFromObject(object);
  const originalCenter = new THREE.Vector3();
  originalBox.getCenter(originalCenter);

  //TODO: Check if this always works
  let isMeshContainsFloor = false;
  object.traverse((child) => {
    if (child.name.toLowerCase().includes("floor")) {
      isMeshContainsFloor = true;
    }
  });

  if (!isMeshContainsFloor) return new THREE.Box3().setFromObject(object);

  const traverseWithScale = (child, parentScale) => {
    // Compute total scale including inherited parent scale
    const totalScale = parentScale.clone().multiply(child.scale);

    if (child.isMesh && !child.name.toLowerCase().includes("floor")) {

      // Compute the bounding box for this mesh
      const childBox = new THREE.Box3().setFromObject(child);

      // Apply the total scale
      childBox.min.multiply(totalScale);
      childBox.max.multiply(totalScale);

      // Expand the overall bounding box
      box.expandByPoint(childBox.min);
      box.expandByPoint(childBox.max);
    }

    // Continue traversal for all children
    child.children.forEach((grandChild) => traverseWithScale(grandChild, totalScale));
  };

  // Start traversal with default scale (1,1,1)
  traverseWithScale(object, new THREE.Vector3(1, 1, 1));

  console.log('FINAL BOUNDING BOX:', box);
  return computeCorrectedBoundingBox(box, object);
};